import React, { useEffect, useState } from "react";
import { useAppStore } from "../../../../../context/store";
import { Dialog, Portal, CloseButton, Button, VStack, Text } from "@chakra-ui/react";

import Type from "../../../../../utilies/Types";
import { deleteAsset } from "../../../../../utilies/GeojsonUtility";
import { getProjects } from "../../../../../utilies/services/project/GetProject";
import { useMapObjects } from "../../../../../context/MapObjectsContext";

const CloseProjectDialog = ({ saveAllLayers }) => {
  // states
  const showCloseProjectDialog = useAppStore((s) => s.showCloseProjectDialog);
  const userData = useAppStore((s) => s.userData);
  const selectedProject = useAppStore((s) => s.selectedProject);
  const viewerRef = useAppStore((s) => s.viewerRef);
  const projects = useAppStore((s) => s.projects);
  const { mapObjects, setMapObjects, mapObjectsRef } = useMapObjects();

  // setters
  const setShowCloseProjectDialog = useAppStore.getState().setShowCloseProjectDialog;
  const setImageGeojsonMode = useAppStore.getState().setImageGeojsonMode;
  const setCamera = useAppStore.getState().setCamera;
  const setSelectedProject = useAppStore.getState().setSelectedProject;
  const setProjects = useAppStore.getState().setProjects;
  const setShowQueryTableDialog = useAppStore.getState().setShowQueryTableDialog;
  const setUserType = useAppStore.getState().setUserType;
  const setUserCanEditing = useAppStore.getState().setUserCanEditing;

  const [isShowSaveChanges, setIsShowSaveChanges] = useState(false);

  useEffect(() => {
    if (showCloseProjectDialog) {
      for (const key in mapObjects) {
        if (mapObjects[key].is_edited || !mapObjects[key].layer_id || !mapObjects[key].project_id) {
          setIsShowSaveChanges(true);
          break;
        }
      }

      let plids = [];
      // collect layer ids from selectedProject
      for (const key2 in selectedProject.layers) {
        plids.push(selectedProject.layers[key2].id);
      }

      for (const key in mapObjects) {
        const lid = mapObjects[key].layer_id;

        // if this layer_id exists in plids → remove it
        if (plids.includes(lid)) {
          plids = plids.filter((x) => x !== lid); // remove the value
        }
      }
      if (plids.length != 0) {
        setIsShowSaveChanges(true);
      }
    } else {
      setIsShowSaveChanges(false);
    }
  }, [showCloseProjectDialog]);

  const close = () => {
    if (selectedProject?.id) {
      let temp2 = selectedProject.contributors;

      if (temp2[0]?.username) {
        for (const key in temp2) {
          if (temp2[key].username == userData.user.username) {
            setUserType(userData.roles);

            if (
              userData.roles.includes(Type.ROLE.ADMIN) ||
              userData.roles.includes(Type.ROLE.ANNOTATOR) ||
              userData.roles.includes(Type.ROLE.DIGITIZER) ||
              userData.roles.includes(Type.ROLE.SUPER_ADMIN)
            ) {
              setUserCanEditing(true);
            } else {
              setUserCanEditing(false);
            }
            break;
          }
        }
      }

      const toRemove = mapObjectsRef.current.filter((d) => d.project_id == selectedProject?.id);

      toRemove.forEach((d) => deleteAsset(viewerRef.current, d, [mapObjectsRef.current, setMapObjects], setImageGeojsonMode, setCamera));

      const updated = mapObjectsRef.current.filter((d) => d.project_id !== selectedProject?.id);

      setMapObjects(updated);
      setSelectedProject(null);

      let temp = [...projects];
      for (const key in temp) {
        temp[key].config_file_data = null;
      }
      setProjects(temp);

      getProjects({
        userData,
        setProjects,
      });

      setShowQueryTableDialog(false);
      setShowCloseProjectDialog(false);
    }
  };

  const saveAndClose = async () => {
    if (saveAllLayers) {
      await saveAllLayers(selectedProject);
    }
    close();
  };

  return (
    <Dialog.Root
      lazyMount
      closeOnInteractOutside={false}
      open={showCloseProjectDialog}
      onOpenChange={(e) => {
        setShowCloseProjectDialog(e.open);
      }}
    >
      <Portal>
        <Dialog.Backdrop />
        <Dialog.Positioner>
          <Dialog.Content>
            <Dialog.Header>
              <VStack gap={0}>
                <Dialog.Title textAlign={"left"} width={"full"}>
                  Confirmation
                </Dialog.Title>
              </VStack>
            </Dialog.Header>

            <Dialog.Body>{isShowSaveChanges ? <Text>Do you want save changes before closing this project?</Text> : <Text>Do you want to close this project?</Text>}</Dialog.Body>

            <Dialog.Footer>
              <Dialog.ActionTrigger asChild>
                <Button variant="outline">Cancel</Button>
              </Dialog.ActionTrigger>
              <Button onClick={close} colorPalette={"red"}>
                Close {isShowSaveChanges && "Without Saving"}
              </Button>
              {isShowSaveChanges && (
                <Button colorPalette={"green"} onClick={saveAndClose}>
                  Save And Close
                </Button>
              )}
            </Dialog.Footer>
            <Dialog.CloseTrigger asChild>
              <CloseButton size="sm" />
            </Dialog.CloseTrigger>
          </Dialog.Content>
        </Dialog.Positioner>
      </Portal>
    </Dialog.Root>
  );
};

export default CloseProjectDialog;
